export default Object.freeze({
  PLANNED: 'PLN',
  ENROLLED: 'ENR',
  COMPLETED: 'COMP',
  WITHDRAWN: 'WD'
})
